import fetch from 'isomorphic-unfetch';
import { graphql } from '../../../../globals/api/requests';

const defaultOptions = {
  credentials: 'include',
  headers: {
    'Content-Type': 'application/json',
  },
};

export const validateEmail = email =>
  fetch(`${window.INTERNAL_HOSTNAME}/_internal/account/validate-email`, {
    ...defaultOptions,
    method: 'POST',
    body: JSON.stringify({ email }),
  }).then(res => res.json());

export const validatePassword = password =>
  fetch(`${window.INTERNAL_HOSTNAME}/_internal/account/validate-password`, {
    ...defaultOptions,
    method: 'POST',
    body: JSON.stringify({ password }),
  }).then(res => res.json());

export const updateMe = data =>
  graphql(
    `
      mutation($data: MeInputType!) {
        updateMe(data: $data) {
          name
          email
          changeEmailConfirmationSent
        }
      }
    `,
    { data }
  );

export const updateSetting = (setting, value) =>
  graphql(
    `
      mutation($data: SettingInputType!) {
        updateSetting(data: $data) {
          success
        }
      }
    `,
    {
      data: {
        setting,
        value,
      },
    }
  );

export const updateAlertSetting = (setting, value) =>
  updateSetting(`alert_method_${setting}`, Number(value));

export default {
  updateMe,
  validateEmail,
  validatePassword,
};
